import styled from 'styled-components'

export const AngledArrowContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 1em;
`
